import { z } from 'zod'

export const MinimumFile = z.object({
  fileName: z.string(),
  type: z.string(),
  fileUrl: z.string()
})

export type MinimumFile = z.infer<typeof MinimumFile>
